/**
 * @generated SignedSource<<54dd4e1061fedb966a2d4ffb861fc4b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceComplianceRoutinesQuery$variables = {
  workspaceId: string;
};
export type WorkspaceComplianceRoutinesQuery$data = {
  readonly workspace: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceComplianceRoutinesList_workspace">;
  };
};
export type WorkspaceComplianceRoutinesQuery = {
  response: WorkspaceComplianceRoutinesQuery$data;
  variables: WorkspaceComplianceRoutinesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceComplianceRoutinesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceComplianceRoutinesList_workspace"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceComplianceRoutinesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routines",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrgTopic",
                "kind": "LinkedField",
                "name": "orgTopic",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "RoutineWorkspaceOccasion",
                "kind": "LinkedField",
                "name": "inProgressOrNextWorkspaceOccasion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "issueCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storesCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storesCompletedCount",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sequenceNumber",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "currentSchedule",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDay",
                        "storageKey": null
                      }
                    ],
                    "type": "RoutineScheduleMonthly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startWeekday",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endWeekday",
                        "storageKey": null
                      }
                    ],
                    "type": "RoutineScheduleWeekly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineScheduleDailyWeekday",
                        "kind": "LinkedField",
                        "name": "weekdays",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Time",
                            "kind": "LinkedField",
                            "name": "startTime",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hour",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minute",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "weekday",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RoutineScheduleDaily",
                    "abstractKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isRoutineSchedule"
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "kind": "ScalarField",
                "name": "isWorkspaceOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "kind": "ScalarField",
                "name": "workspaceOwnerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "descriptionImages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbhash",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlExpiresAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "descriptionFiles",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrg",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1bc26d8f269d3ef296b2cd9334e60fc3",
    "id": null,
    "metadata": {},
    "name": "WorkspaceComplianceRoutinesQuery",
    "operationKind": "query",
    "text": "query WorkspaceComplianceRoutinesQuery(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    id\n    ...WorkspaceComplianceRoutinesList_workspace\n  }\n}\n\nfragment FileIconBox_file on File {\n  type\n  isOrg\n  ...FileIcon_File\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment ListItemDescriptionContentFiles_files on File {\n  id\n  ...FileIconBox_file\n}\n\nfragment ListItemDescriptionContent_images on Image {\n  id\n  ...Image_image\n}\n\nfragment WorkspaceComplianceRoutinesList_workspace on Workspace {\n  id\n  topics {\n    __typename\n    id\n  }\n  routines {\n    title\n    orgTopic {\n      name\n      id\n    }\n    inProgressOrNextWorkspaceOccasion(workspaceId: $workspaceId) {\n      issueCount\n      storesCount\n      storesCompletedCount\n      id\n    }\n    currentSchedule {\n      __typename\n      ... on RoutineScheduleMonthly {\n        endDay\n        startDay\n      }\n      ... on RoutineScheduleWeekly {\n        startWeekday\n        endWeekday\n      }\n      ... on RoutineScheduleDaily {\n        weekdays {\n          startTime {\n            hour\n            minute\n          }\n          weekday\n        }\n      }\n    }\n    id\n    ...WorkspaceRoutinesListItem_Routine\n  }\n}\n\nfragment WorkspaceRoutinesListItemContent_routine on Routine {\n  title\n  description\n  descriptionImages {\n    ...ListItemDescriptionContent_images\n    id\n  }\n  descriptionFiles {\n    ...ListItemDescriptionContentFiles_files\n    id\n  }\n}\n\nfragment WorkspaceRoutinesListItemScheduleDaily_schedule on RoutineScheduleDaily {\n  weekdays {\n    weekday\n    startTime {\n      hour\n      minute\n    }\n  }\n}\n\nfragment WorkspaceRoutinesListItemScheduleMonthly_schedule on RoutineScheduleMonthly {\n  startDay\n  endDay\n}\n\nfragment WorkspaceRoutinesListItemScheduleWeekly_schedule on RoutineScheduleWeekly {\n  startWeekday\n  endWeekday\n}\n\nfragment WorkspaceRoutinesListItemSchedule_schedule on RoutineSchedule {\n  __isRoutineSchedule: __typename\n  __typename\n  ... on RoutineScheduleDaily {\n    ...WorkspaceRoutinesListItemScheduleDaily_schedule\n  }\n  ... on RoutineScheduleMonthly {\n    ...WorkspaceRoutinesListItemScheduleMonthly_schedule\n  }\n  ... on RoutineScheduleWeekly {\n    ...WorkspaceRoutinesListItemScheduleWeekly_schedule\n  }\n}\n\nfragment WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion on RoutineWorkspaceOccasion {\n  storesCompletedCount\n  storesCount\n}\n\nfragment WorkspaceRoutinesListItem_Routine on Routine {\n  id\n  isWorkspaceOwner(workspaceId: $workspaceId)\n  workspaceOwnerName(workspaceId: $workspaceId)\n  ...WorkspaceRoutinesListItemContent_routine\n  inProgressOrNextWorkspaceOccasion(workspaceId: $workspaceId) {\n    ...WorkspaceRoutinesListItemStatus_RoutineWorkspaceOccasion\n    sequenceNumber\n    issueCount\n    id\n  }\n  orgTopic {\n    name\n    id\n  }\n  currentSchedule {\n    __typename\n    ...WorkspaceRoutinesListItemSchedule_schedule\n  }\n}\n"
  }
};
})();

(node as any).hash = "819c3da9f4c4eb960bd0aea952702b18";

export default node;
